var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 8.74825H4.75V7.24825H0.25V0.382748C0.250011 0.317584 0.267003 0.253548 0.2993 0.196951C0.331597 0.140354 0.378086 0.0931496 0.434182 0.0599911C0.490279 0.0268326 0.554049 0.00886432 0.619205 0.00785729C0.684361 0.00685027 0.748655 0.0228393 0.80575 0.0542483L14.6522 7.66975C14.711 7.70212 14.7601 7.74968 14.7942 7.80746C14.8284 7.86524 14.8464 7.93113 14.8464 7.99825C14.8464 8.06537 14.8284 8.13125 14.7942 8.18904C14.7601 8.24682 14.711 8.29438 14.6522 8.32675L0.80575 15.9422C0.748655 15.9737 0.684361 15.9896 0.619205 15.9886C0.554049 15.9876 0.490279 15.9697 0.434182 15.9365C0.378086 15.9033 0.331597 15.8561 0.2993 15.7995C0.267003 15.7429 0.250011 15.6789 0.25 15.6137V8.74825Z",
    fill: "#1B75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButton);
export default __webpack_public_path__ + "static/media/sendButton.7bf4be71d54a2218f582374e52bc8273.svg";
export { ForwardRef as ReactComponent };